import { GameData } from "./gamestate/gameData";

import {
  stopAutoPlay,
  recoverGameBar,
  enablePlay,
  enableBet,
  enableCollect,
  enableCtBonusSpin,
  enableChangeBet,
  displayGambleBtn,
  gambleClick,
  checkUserBalToBet,
  enablePlayIfJackpotNotAvailable,
} from "../../common/functions/Functions_GameBar";
// import { getOptionPages } from "./optionPages";
import { closeOptionWindow } from "../../common/functions/Functions_OptionWindow";
import {
  updateUseInfoText,
  updateBalance,
  updateWinBar,
  // jackpotWinCheck,
  setAllowedInputs,
  displayeGambleGame,
  jackpotWinOnNonWinningGameSpin,
  isNullOrUndefined,
} from "../../common/functions/Functions_General";
import { GameBaseSetup } from "../../common/gameLib/BaseGame/GameBaseSetup";
// import { CommonData } from "../../common/datastructures/gamestate/gameData";

import {
  enableEmulationInterfaceOnFeatureSelect,
  updateEmulationStakeUse,
  updateEmulationWinBalance,
} from "../../common/gameLib/Replay/emulation/functionsEmulations";

// import { translateCopyGameDataToLocalTaleOfTime } from "./translateGameContext";
// import { BonusSymbolPickerBookAnimation } from "./GameSpinner/BonusGame_BookOf/symbolSelector/bonusSymbolPickAnimation";

export function updateWin(activeGameData: GameData) {
  // console.log("==>call Update" )
  let winamount = 0;
  enablePlay(false, activeGameData);
  //-new
  winamount = activeGameData.GameContext().gameRoundBalance.credits.amount;
  activeGameData.winValue.updateValue(winamount);

  // if (activeGameData.GameContext().win.credits.amount == 0) {
  //   activeGameData.freeSpinMode.setMessageDisplay();
  // }
  if (activeGameData.GameContext().finished) {
    if (activeGameData.mainGame.getIsExpandBonusActive() == false) {
      let isNotBigWin =
        activeGameData.newWinAnimation.isBigWin(
          winamount,
          activeGameData.betSelected.value
        ) == false;
      let isBonusGame =
        activeGameData.GameContext().bonusGameResult != undefined;
      let winLines = activeGameData.GameContext().baseGameResult.winCombinations
        .length;
      if (isBonusGame) {
        winLines = activeGameData.GameContext().bonusGameResult.winCombinations
          .length;
      }

      // check if bigWinorNot and display the win animation only after the winlines animation
      if (isNotBigWin || winLines == 0) {
        //if used action is expand then check the  animation only at the end of the  exapnd
        activeGameData.newWinAnimation.displayWin(
          winamount,
          activeGameData.betSelected.value
        );
      }
    }
  } else {
    let winSpin = activeGameData.GameContext().win.credits.amount;
    // if(activeGameData.GameContext().finished)
    // {
    //    winSpin = activeGameData.GameContext().gameRoundBalance.credits.amount;
    // }

    if (activeGameData.mainGame.getIsExpandBonusActive() == false) {
      //-display small win animations
      if (winamount > 0) {
        // && winRatio<bigWinRatio )

        // check if bigWinorNot and display the win animation only after the winlines animation
        if (
          activeGameData.newWinAnimation.isBigWin(
            winamount,
            activeGameData.betSelected.value
          ) == false
        ) {
          activeGameData.newWinAnimation.displayWin(
            winSpin,
            activeGameData.betSelected.value
          );
        }
      }
    }
  }
  if (activeGameData.GameContext().bonusGameResult != undefined) {
    winamount = activeGameData.GameContext().win.credits.amount;
    activeGameData.winValue.updateValue(winamount);
  }

  updateWinBar(true, activeGameData);
  // console.log("update WIN");
  activeGameData.mainGame.setBonusLeft(
    activeGameData.GameContext().gameRoundBalance.bonusSpins
  );

  if (
    activeGameData.GameContext().bonusGameResult != undefined &&
    //--
    activeGameData.GameContext().bonus == false &&
    activeGameData.GameContext().gameRoundBalance.bonusSpins === 0
    // &&
    // activeGameData.WildGame.isWildVisible() == false
  ) {
    // console.log("SANTA On LAST SPIN")
    displayBonusEndResultMessage(activeGameData);
  } else if (winamount == 0) {
    enablePlayIfJackpotNotAvailable(activeGameData);
    setAllowedInputs(activeGameData);
  }
  // else if (winamount > 0) {
  //   let totalBonuswin = activeGameData.GameContext().gameRoundBalance.credits
  //     .amount;
  //   if (
  //     activeGameData
  //       .GameContext()
  //       .allowedInputActions.indexOf(
  //         activeGameData.API_handler.getServerActionCollect()
  //       ) >= 0
  //   ) {
  //     activeGameData.newWinAnimation.displayWin(
  //       totalBonuswin,
  //       activeGameData.betSelected.value
  //     );
  //   }
  // }

  //display winamimations
  displayWinAnimation(activeGameData);
}
function displayWinAnimation(activeGameData: GameData) {
  activeGameData;
}
function displayBonusEndResultMessage(activeGameData: GameData) {
  activeGameData.disableAllBtns(activeGameData);

  // let totalBonuswin = activeGameData.GameContext().gameRoundBalance.credits
  //   .amount;
  // if (activeGameData.GameContext().finished) {
  //   activeGameData.newWinAnimation.displayWin(
  //     totalBonuswin,
  //     activeGameData.betSelected.value
  //   );
  // }

  // console.log("showEndMsg", totalBonuswin);
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  activeGameData.playable = false;
  activeGameData.gameBar.setBlackAndWhitePlay();
  if (activeGameData.replayMode == true) {
    setTimeout(() => {
      bonusMessageBox.displayMessageOut();
    }, 1000);
  } else {
    // time to wait
    let totalWinlines = activeGameData.GameContext().bonusGameResult
      .winCombinations.length;
    let waitPerWinline = activeGameData.mainGame
      .getWinlinesBuilder()
      .getBaseSpeed();
    if (
      activeGameData.GameContext().usedInputAction ==
      activeGameData.API_handler.getServerActionExpandBookOfTime()
    ) {
      waitPerWinline = activeGameData.mainGame
        .getWinlinesBuilder()
        .getBoostSpeed();
    }

    let isBigWin = activeGameData.newWinAnimation.isBigWin(
      activeGameData.GameContext().gameRoundBalance.credits.amount,
      activeGameData.betSelected.value
    );

    if (isBigWin == false) {
      // console.log("DISPLAY OUT MESSAGE")
      let endWaitTime = totalWinlines * waitPerWinline;
      setTimeout(() => {
        bonusMessageBox.displayMessageOut();
      }, endWaitTime);
    }
  }

  // activeGameData.displayBonusTotalFn= (): void => { };
  // console.log('BONUS GAME END MESSAGE POP HERE')
}

export function resetExtraSpin(activeGameData: GameData) {
  for (var i = 0; i < activeGameData.mainGame.getTotalColumns(); i++) {
    for (let j = 0; j < 5; j++) {
      activeGameData.mainGame.getColumn(i).setExtraSpinTweenCol(j); //.tileSprite[j].setExtraSpinTweenReset();
    }
  }

  // activeGameData.mainGame.setBonusExtraSpinVisible(false); //.dragonHighlighter.enableOrb(false);
}

export function closeBonusGameMode(activeGameData: GameData) {
  if (activeGameData.bonusGameMode && activeGameData.bonusBG) {
    //&& activeGameData.bonusGameInfos.container.alpha===1)
    //close bonusgameMode items
    displayBonusGameInfosWindow(false, activeGameData);
    // activeGameData.bonusGameInfos.gameMessageDisplay.close();
    closeBonusWinMessageBox(activeGameData);
    bonusGameEffects(false, activeGameData);
  }
}
export function closeBonusWinMessageBox(activeGameData: GameData) {
  // activeGameData.bonusGameInfos.gameMessageDisplay.display(bool); //open the  message window
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  bonusMessageBox.close();
  // activeGameData.bonusGameInfos.gameMessageDisplay.close();
}
// export function displayBonusIconDragonSymbol(
//   i: number,
//   activeGameData: GameData
// ) {
//   activeGameData.mainGame.setBonusSymbolLabelOnSelected(i); //.dragonHighlighter.enableIconSelected(i);
// }
// export function displayFireAroundDragonSymbol(
//   i: number,
//   activeGameData: GameData
// ) {
//   // activeGameData.mainGame.dragonHighlighter.enableSelected(i);
//   activeGameData.mainGame.setBonusSymbolFocusOnSelected(i); //dragonHighlighter.enableSelected(i);
// }
// export function hideDisplayFireAroundDragonSymbol(activeGameData: GameData) {
//   // activeGameData.mainGame.dragonHighlighter.enableFire(false);
//   activeGameData.mainGame.setBonusSymbolFocus(false);
// }
// export function disableDragonFX(activeGameData: GameData) {
//   // activeGameData.mainGame.dragonHighlighter.enableIcon(false);
//   // activeGameData.mainGame.dragonHighlighter.enableFire(false);
//   activeGameData.mainGame.setBonusSymbolFX(false);
// }
export function displayBonusGameInfosWindow(
  bool: boolean,
  activeGameData: GameData
) {
  if (bool) {
    // let tween = activeGameData.bonusGameInfos.getFadeIN();
    // tween.start();

    activeGameData.bonusGameInfos.setVisible(true);
    activeGameData.bonusGameInfos.setNewOrbMultiplierValue();
  } else {
    // activeGameData.bonusGameInfos.setTweenReset(); //container.alpha===1)
    activeGameData.bonusGameInfos.setVisible(false);
  }
  // activeGameData.bonusGameInfos.container.alpha=bool
}
// export function highlightOrbsonWinline(
//   winlineLengthValue: number,
//   activeGameData: GameData
// ) {
//   // console.log(winlineLengthValue)
//   if (activeGameData.bonusGameMode && activeGameData.bonusGameModeStarted) {
//     disablehighlightOrbsonWinline(activeGameData);

//     if (winlineLengthValue == 3) {
//       activeGameData.bonusGameInfos.setOrbAlpha(0, 1);
//     } //.smallOrbs[0].alpha = 1 }
//     if (winlineLengthValue == 4) {
//       activeGameData.bonusGameInfos.setOrbAlpha(1, 1);
//     } //smallOrbs[1].alpha = 1 }
//     if (winlineLengthValue == 5) {
//       activeGameData.bonusGameInfos.setOrbAlpha(2, 1);
//     } //smallOrbs[2].alpha = 1 }
//   }
// }
// export function disablehighlightOrbsonWinline(activeGameData: GameData) {
//   for (var i = 0; i < 3; i++) {
//     activeGameData.bonusGameInfos.setOrbAlpha(i, 0.5); //smallOrbs[i].alpha = 0.5
//   }
// }

export function disableAllBtns(activeGameData: GameData) {
  stopAutoPlay(activeGameData);
  // enableGamble(false, activeGameData);

  enableBet(false, activeGameData);
  enableCollect(false, activeGameData);
  enableCtBonusSpin(false, activeGameData);
  activeGameData.gameBar.setGambleBtnsButtonMode(false);
  activeGameData.gameBar.setButtonMode(false);
  activeGameData.jackPotGame.setCountersButtonVisible(false);
  // activeGameData.replay.disable(true);
}
export function resetAllBtns(activeGameData: GameData) {
  activeGameData.gameBar.setButtonMode(true);

  activeGameData.jackPotGame.setCountersButtonVisible(true);
  if (activeGameData.betResponse.gameContext != undefined) {
    setAllowedInputs(activeGameData);
  }

  // activeGameData.replay.disable(false);
}

export function checkSymbolToExpand(activeGameData: GameData) {
  //--if expand wild is present do an expand wil request
  // console.log(  activeGameData.API_handler.getServerActionExpand())

  activeGameData.santaExpandable = true;

  setNewServerAction(activeGameData); //--check and define new action
  if (
    activeGameData.expandRequested == false &&
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionExpandBookOfTime()
      ) >= 0
  ) {
    activeGameData.playable = false;
    activeGameData.expandRequested = true;
    expandSymbolRequest(activeGameData);
  } else {
    activeGameData.santaExpandable = false;
    // activeGameData.WildGame.reloadSanta();
  }
}

export function expandSymbolRequest(activeGameData: GameData) {
  activeGameData.serverAction = activeGameData.API_handler.getServerActionExpandBookOfTime();

  if (activeGameData.replayMode == false) {
    var expandData = {
      action: activeGameData.serverAction,
      value: activeGameData.betSelected.value,
      // a:12
    };

    // activeGameData.replay.incrementIndex();
    // activeGameData.replay.getNewStepData()

    console.log(
      "_________________________________________>REQUEST EXPAND"
      // activeGameData.serverAction,
      // expandData
    );
    activeGameData.API_handler.GetGamePlayResult(
      expandData,
      activeGameData.ExpandSantaSuccess,
      activeGameData.betFail
    );
  } else {
    activeGameData.replay.incrementIndex();
    activeGameData.replay.getRoundContextData(); //--apply incrementation index and copy new context to the gamecontext
    //  console.log("contextNUM",activeGameData.betResponse.gameContext.contextNumber);
    activeGameData.ExpandSantaSuccess(activeGameData.betResponse);
  }
}

export function setNewServerAction(activeGameData: GameData) {
  // console.log("define new Action," ,activeGameData.GameContext().allowedInputActions)
  if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionBonusSpin()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionBonusSpin();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionBet()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionBet();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionCollect()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionCollect();
  } else if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionExpandBookOfTime()
      ) >= 0
  ) {
    activeGameData.serverAction = activeGameData.API_handler.getServerActionExpandBookOfTime();
  }
}
export function expandSuccess(data: any, activeGameData: GameData) {
  // activeGameData.gameBar.setBlackAndWhitePlay();
  activeGameData.gameBar.setPlayButtonIndex(1);
  // console.log("setColorBack")
  activeGameData.mainGame.setWinlineHidden();

  activeGameData.betResponse = data;
  // translateCopyGameDataToLocalTaleOfTime(activeGameData,data);

  setNewServerAction(activeGameData);
  activeGameData.balance.updateValue(
    activeGameData.betResponse.playerBalance.creditsBalance.amount
  ); //update the balance  but dont necessarly update  the visaul as in the end of bonus game , it will do the update on message close.

  activeGameData.playable = true;
  activeGameData.mainGame.expandSuccess();
}

export function toggleBonusGameMode(activeGameData: GameData) {
  if (
    activeGameData.GameContext().bonus ||
    activeGameData.GameContext().gameRoundBalance.bonusSpins > 0
  ) {
    activeGameData.gameMode = "bonusGame";
    activeGameData.bonusGameMode = true;

    // console.log(
    //   "ENABLE BONUS GAME",
    //   activeGameData.gameMode,
    //   activeGameData.bonusGameMode
    // );
  } else {
    activeGameData.gameMode = "normalGame";
    activeGameData.bonusGameMode = false;
    bonusGameEffects(false, activeGameData);
    disableFireWorks(activeGameData);
    addWinToUserInfo(
      activeGameData.GameContext().win.credits.amount,
      activeGameData
    );
    //

    // if (activeGameData.bonusGameInfos.getIsVisibile) {
    //   displayBonusGameInfosWindow(false, activeGameData);
    //   musicSelect(0, activeGameData);

    // }

    // console.log(3)
  }
}

export function replaceAllWithBonus(activeGameData: GameData, bool: boolean) {
  if (bool) {
    // console.log('rrrr')
    //bonus game start change all symbols to zero
    if (
      activeGameData.bonusGameModeStarted == false &&
      activeGameData.GameContext().bonus
    ) {
      if (
        activeGameData.mainGame.getIsGameStarted() &&
        activeGameData.replayMode
      ) {
        //on replay mode, the bonus win appears instantly  if player skip through rounds,
        // and if they click the  continue btn as it is spinning the game will still go on in the background, so to avoid that  it is necessary to check and stop it
        activeGameData.mainGame.stopTicker();

        activeGameData.mainGame.setGameStop(
          activeGameData.betResponse.gameContext.contextData
        );
        //reset the position y
        let cols = activeGameData.mainGame.getAllColumns();
        for (var i = 0; i < cols.length; i++) {
          cols[i].setAllDefault();
        }
      }
      activeGameData.mainGame.setbonusGameOverlayVisible(false); //---display showtime
      activeGameData.mainGame.checkForRandomSymbol(true);

      //
      // return

      let lastIndex = activeGameData.allDice.length - 1;
      let empty = [lastIndex, lastIndex, lastIndex];

      activeGameData.mainGame.setFixedDices(empty, empty, empty, empty, empty);

      activeGameData.mainGame.setWinlineHidden();
    }
    // console.log("HEAREF")
  } else {
    //set back normal dice after bonus game ended

    //--set back the symbols back to normal game
    for (let i = 0; i < activeGameData.mainGame.getAllColumns().length; i++) {
      activeGameData.mainGame.getAllColumns()[i].swapSymbolPresent(true);
    }

    let gameContext = activeGameData.GameContext();

    let r1 = [
      gameContext.baseGameResult.reels[0][0] - 1,
      gameContext.baseGameResult.reels[0][1] - 1,
      gameContext.baseGameResult.reels[0][2] - 1,
    ];
    let r2 = [
      gameContext.baseGameResult.reels[1][0] - 1,
      gameContext.baseGameResult.reels[1][1] - 1,
      gameContext.baseGameResult.reels[1][2] - 1,
    ];
    let r3 = [
      gameContext.baseGameResult.reels[2][0] - 1,
      gameContext.baseGameResult.reels[2][1] - 1,
      gameContext.baseGameResult.reels[2][2] - 1,
    ];
    let r4 = [
      gameContext.baseGameResult.reels[3][0] - 1,
      gameContext.baseGameResult.reels[3][1] - 1,
      gameContext.baseGameResult.reels[3][2] - 1,
    ];
    let r5 = [
      gameContext.baseGameResult.reels[4][0] - 1,
      gameContext.baseGameResult.reels[4][1] - 1,
      gameContext.baseGameResult.reels[4][2] - 1,
    ];
    activeGameData.mainGame.setFixedDices(r1, r2, r3, r4, r5);
    //change back to normal dice
    // console.log("switch")
    activeGameData.mainGame.changeBonusSymbolTint(true);
    checkSymbolToExpand(activeGameData);
  }
  // checkSymbolToExpand(activeGameData);
}

export function disableFireWorks(activeGameData: GameData) {
  activeGameData.environment.setFireWorks(false);
}
function bonusGameEffects(bool: boolean, activeGameData: GameData) {
  // console.log(activeGameData.environment.glowL.scale.x)
  if (bool) {
    if (activeGameData.environment.getGlowScale() === 8) {
      activeGameData.bonusBG = true;
      activeGameData.environment.setGlowScale(14);
      activeGameData.background.setNewTexture("game_BGB.png");

      //--portraitmode bg change
      activeGameData.portraitBGSky.texture = PIXI.Texture.fromFrame(
        "game_BGB.png"
      );
    }

    // playEyeAnimation(activeGameData, true);

    // console.log("playFireAnimationEye")
  } else if (activeGameData.environment.getGlowScale() === 14) {
    activeGameData.bonusBG = false;
    activeGameData.environment.setGlowScale(8);
    activeGameData.background.setNewTexture("game_BGDark.png");

    // playEyeAnimation(activeGameData, false);
    //--portraitmode bg change
    activeGameData.portraitBGSky.texture = PIXI.Texture.fromFrame(
      "game_BGDark.png"
    );
  }
}
function addWinToUserInfo(winnings: number, activeGameData: GameData) {
  if (winnings > 0) {
    activeGameData.msgtotalWIN += winnings;
  }

  activeGameData.msgtotalLOSE =
    activeGameData.msgtotalBET - activeGameData.msgtotalWIN; //+=activeGameData.betSelected.value;

  // console.log("BET:"+activeGameData.msgtotalBET+"  WIN"+activeGameData.msgtotalWIN+"  LOSE"+activeGameData.msgtotalLOSE);

  updateUseInfoText(activeGameData);
}

// export function autoUpdateSettingsPage(activeGameData: GameData) {
//   if (
//     screenfull &&
//     screenfull.isFullscreen === true &&
//     activeGameData.gameOption.getFullScreenIsOn() === false
//   ) {
//     activeGameData.gameOption.setFullScreenOn(true);
//   }
//   if (
//     activeGameData.normalGameMusic.volume() > 0 &&
//     activeGameData.gameOption.getBgMusicIsOn() === false
//   ) {
//     activeGameData.gameOption.setBgMusicOn(true);
//   }
//   if (
//     activeGameData.bonusGameMusic.volume() > 0 &&
//     activeGameData.gameOption.getBonusMusicIsOn() === false
//   ) {
//     activeGameData.gameOption.setBonusMusicOn(true);
//   }
//   if (
//     activeGameData.sound.volume() > 0 &&
//     activeGameData.gameOption.getSoundIsOn() === false
//   ) {
//     activeGameData.gameOption.setSoundOn(true);
//   }
//   if (
//     screenfull &&
//     screenfull.isFullscreen === false &&
//     activeGameData.gameOption.getFullScreenIsOn() === true
//   ) {
//     activeGameData.gameOption.setFullScreenOn(false);
//   }
//   if (
//     activeGameData.normalGameMusic.volume() === 0 &&
//     activeGameData.gameOption.getBgMusicIsOn() === true
//   ) {
//     activeGameData.gameOption.setBgMusicOn(false);
//   }
//   if (
//     activeGameData.bonusGameMusic.volume() === 0 &&
//     activeGameData.gameOption.getBonusMusicIsOn() === true
//   ) {
//     activeGameData.gameOption.setBonusMusicOn(false);
//   }
//   if (
//     activeGameData.sound.volume() === 0 &&
//     activeGameData.gameOption.getSoundIsOn() === true
//   ) {
//     activeGameData.gameOption.setSoundOn(false);
//   }
//   // console.log("autoooo");
// }
function playWinAnimationsCheck(activeGameData: GameData) {
  let allowPlayClick = false;
  if (activeGameData.replayMode == true) {
    allowPlayClick = true;
  } else if (activeGameData.newWinAnimation.isActive() === false) {
    //-make sure that sergio winanimation is complete
    // console.log('NO WIN ANIMATIOn ACTIVE')
    allowPlayClick = true;
  }

  // console.log("check",allowPlayClick)
  return allowPlayClick;
}

export function onPlayButtonDown(activeGameData: GameData) {
  activeGameData.minimumStakePopup.onFirstSpin();
  if (
    activeGameData.mainGame.getBonusSymbolPickerBookAnimation().isVisible() &&
    activeGameData.replayMode == false
  ) {
    // console.log("skip to symbol selection screen end while playing with keyboard");
    activeGameData.mainGame.getBonusSymbolPickerBookAnimation().goToResults();
    return;
  }
  if (activeGameData.mainGame.getExpandAnimation().getIsActive()) {
    // console.log('IS EXPANDING');
    activeGameData.playable = false;
    return;
  }
  if (playWinAnimationsCheck(activeGameData)) {
    let playBtnMode = activeGameData.gameBar.getplayBtnIndex();

    // activeGameData.mainGame.setOrbLightsDefault(); //orbLight.stop();
    if (playBtnMode === 2 && activeGameData.playable) {
      // console.log("COLLECT")

      // if (activeGameData.autoPlayTicker.started === false) {}
      activeGameData.newWinAnimation.stop();
      // activeGameData.sergioWinAnimation.setVisible(false);

      activeGameData.gameBar.setGambleBtnsButtonMode(false);
      displayeGambleGame(false, activeGameData); //close gamble game Interface;
      if (activeGameData.bonusGameInfos.getIsVisibile() === true) {
        // if bonus Frame is open
        displayBonusGameInfosWindow(false, activeGameData);
        // displayBonusGameInfosWindowText(false,activeGameData);
      }

      activeGameData.gameBar.setPlayButtonIndex(3);
      activeGameData.gameBar.setBlackAndWhitePlay();
      activeGameData.mainGame.disableAllSymbolsAnimation();
      activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
      if (activeGameData.replayMode == false) {
        var collectData = { action: activeGameData.serverAction };
        // console.log(
        //   "==================================>COLLECT",
        //   activeGameData.serverAction
        // );
        activeGameData.API_handler.GetGamePlayResult(
          collectData,
          activeGameData.collectSuccess,
          activeGameData.collectFail
        );
      } else {
        // console.log(activeGameData.replayMode, "CCCCCCCCCCCOLLECT")
        activeGameData.collectSuccess(activeGameData.betResponse);
      }
    } else if (activeGameData.playable && playBtnMode === 0) {
      if (activeGameData.environment) {
        disableFireWorks(activeGameData);
      } // if fireworks is playing it stops once player hit play
      activeGameData.mainGame.setWinlineHidden();
      // console.log(activeGameData.balance.value >= activeGameData.betSelected.value,activeGameData.balance.value, activeGameData.betSelected.value)

      if (
        activeGameData.balance.value >= activeGameData.betSelected.value ||
        activeGameData.gameMode === "bonusGame"
      ) {
        if (activeGameData.gameMode === "bonusGame") {
          stopAutoPlay(activeGameData);
        }

        startPlaying(activeGameData);
      }
    } else if (
      activeGameData.preSkip == false &&
      activeGameData.mainGame.getIsGameStarted()
    ) {
      activeGameData.preSkip = true;
      activeGameData.gameBar.setBlackAndWhitePlay();
      // console.log('PRESKIP')
    }
  }
}

export function resetFx(activeGameData: GameData) {
  activeGameData.totalBonusSymbolVisible = 0;
  activeGameData.mainGame.setExpandedWinlinesActive(false);
  activeGameData.mainGame.getExpandAnimation().clear();
  closeOptionWindow(activeGameData); //localfunction
  activeGameData.mainGame.changeBonusSymbolTint(false);
  activeGameData.mainGame.setbonusGameOverlayVisible(false);
  activeGameData.mainGame.checkForRandomSymbol(false);
  activeGameData.mainGame.clearExtraBonusSPinWindow();
  activeGameData.mainGame.getPostExpandAnim().clearAll();

  activeGameData.expandRequested = false;

  enablePlay(false, activeGameData);
  enableChangeBet(false, activeGameData); //disablebet;
  let bonusMessageBox = activeGameData.bonusGameInfos.getMessageBox();
  if (bonusMessageBox.getAlpha()) {
    bonusMessageBox.close();
  }
  //close popper
  activeGameData.autoplayPopper.close();
  activeGameData.betPopper.close();
  activeGameData.jackPotGame.closeDetailsPanel();

  if (activeGameData.isTournament) {
    activeGameData.tournamentmode.closeRankingsPopup();
  }
  if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionBet()
      ) >= 0 &&
    activeGameData.GameContext().bonusGameResult == undefined
  )
    activeGameData.mainGame.setBonusLeftVisible(false);
  activeGameData.API_handler;

  // activeGameData.environment.checkMusicAndBonusMode();
}

function startPlaying(activeGameData: GameData) {
  if (activeGameData.BuyBonus.getIsOpen()) {
    //when the  buy screen is open ignore all te requests to play
    return;
  }
  if (
    activeGameData.serverAction ===
    activeGameData.API_handler.getServerActionExpandBookOfTime()
  ) {
    //if request is expand wild  DO nothing
    // console.log("ignore request",activeGameData.serverAction );
    if (activeGameData.replayMode) {
      // console.log(relpl)
      expandSymbolRequest(activeGameData);
    }
  } else {
    if (activeGameData.gambleGame.getGambleVisibility()) {
      activeGameData.gambleGame.startGamble(false);
    }
    // activeGameData.mainGame.setbonusGameOverlayVisible(false);

    activeGameData.mainGame.setFocused(false);
    resetFx(activeGameData);

    let gameStarted = activeGameData.mainGame.getIsGameStarted();

    if (gameStarted === false) {
      //--
      activeGameData.preSkip = false;
      // activeGameData.gameBar.setBlackAndWhitePlay(); //change the color of play btn to black and white
      activeGameData.gameBar.setPlayButtonIndex(1); //skippable
      activeGameData.gameBar.setBlackAndWhitePlay(); //change the color of play btn to black and white
      //----------------
      // if (activeGameData.autoPlayTicker.started === false) {}
      activeGameData.newWinAnimation.stop();
      // activeGameData.sergioWinAnimation.setVisible(false);

      activeGameData.gameSkippable = false;
      activeGameData.activePlaying = true; //game is playing
      activeGameData.skipAnimation = false; //skipBool
      //activeGameData.mainGame.skipAnimation=activeGameData.skipAnimation;

      //infinitewin
      activeGameData.infiniteSpin = true; //set infinitespin bool to tru

      if (activeGameData.gameMode === "bonusGame") {
        activeGameData.bonusGameMode = true;
        activeGameData.bonusGameModeStarted = true;
        // disablehighlightOrbsonWinline(activeGameData);
      } else if (activeGameData.gameMode === "normalGame") {
        activeGameData.bonusGameMode = false;
        activeGameData.bonusGameModeStarted = false;
      }

      // console.log(
      //   "==========play btn press ======>",
      //   activeGameData.serverAction
      // );
      activeGameData.BuyBonus.enableBuyBonusIfAllowed(false);
      if (activeGameData.replayMode == false) {
        //---default request
        var betData = {
          action: activeGameData.serverAction,
          value: activeGameData.betSelected.value,
          // a:12
        };

        activeGameData.spinTimeCounter = Date.now();
        activeGameData.API_handler.GetGamePlayResult(
          betData,
          activeGameData.betSuccess,
          activeGameData.betFail
        );
        enableEmulationInterfaceOnFeatureSelect(activeGameData, false);
      } else {
        activeGameData.betSuccess(activeGameData.betResponse);
      }
      activeGameData.winValue.updateValue(0);
      updateWinBar(true, activeGameData);
      activeGameData.mainGame.startTicker(); //start infinite spin until result from server is received

      if (activeGameData.autoCountListselected > 0) {
        if (activeGameData.newWinAnimation.isActive() === false) {
          autoplayStart(activeGameData);
        }
      }
    } else if (
      activeGameData.betResponse.hasOwnProperty("jackpotContext") === false
    ) {
      activeGameData.skipGame(activeGameData);
      activeGameData.gameBar.setBlackAndWhitePlay();
    }

    if (
      activeGameData.autoCountListselected == 0 &&
      activeGameData.autoPlayTicker.started
    ) {
      //if player has used all the balance or if player  has reached the 0 stop ticker
      // enablePlay(false, activeGameData);
      stopAutoPlay(activeGameData);
    }
  }
}

function autoplayStart(activeGameData: GameData) {
  activeGameData.autoCountListselected--;
  activeGameData.gameBar.setAutoPlayCount(activeGameData.autoCountListselected);
  if (activeGameData.autoPlayTicker.started === false) {
    activeGameData.autoPlayTicker.start();
  }
}

// export function skipGame(activeGameData: GameData) {
//   if (
//     activeGameData.skipAnimation === false &&
//     activeGameData.infiniteSpin === false
//   ) {
//     // && activeGameData.mainGame.skipEnabled)
//     enablePlay(false, activeGameData);
//     activeGameData.skipAnimation = true;
//     // stopAutoPlay(activeGameData);
//     // console.log('skip')
//   }
// }

export function clearOnReplayOpenClose(activeGameData: GameData) {
  activeGameData.totalBonusSymbolVisible = 0;
  // things that should be reset on bonus open and close
  activeGameData.mainGame.setbonusGameOverlayVisible(false); //--hide  overlay if  is visible
  activeGameData.mainGame.forceCloseBonusSymbolSelectionScreen();
  activeGameData.mainGame.setExpandedWinlinesActive(false);
  activeGameData.mainGame.getExpandAnimation().clear();
  activeGameData.mainGame.clearExtraBonusSPinWindow();
  activeGameData.mainGame.getPostExpandAnim().clearAll();

  activeGameData.expandRequested = false;
  activeGameData.bonusGameModeStarted = false;
  activeGameData.mainGame.setBonusLeftVisible(false);
  // activeGameData.mainGame.setOrbLightsDefault();
  closeBonusWinMessageBox(activeGameData);
  activeGameData.mainGame.setWinlineHidden();
  if (activeGameData.jackPotGame.isJackpotOpen()) {
    activeGameData.jackPotGame.stop();
  }

  if (activeGameData.gambleGame.getGambleVisibility()) {
    activeGameData.gambleGame.startGamble(false);
  }
  activeGameData.newWinAnimation.stop();
  activeGameData.environment.checkBonusGameMusic();

  //---reset the message counter
  activeGameData.bonusGameInfos.getMessageBox().resetMessageIndex();

  ///----RESET GAME SPECIFIC ELEEMNTS
  // activeGameData.GameContext().bonus=false;//set the GAMECONTEXT TO BONUS FALSE;
  activeGameData.serverAction = activeGameData.API_handler.getServerActionBet();
  activeGameData.GameContext().usedInputAction = activeGameData.serverAction;
  activeGameData.environment.isBonusGame(false); //reset the game bg to the default
  activeGameData.mainGame.stopTicker(); //stop the ticker
  activeGameData.mainGame.getExpandAnimation().clear(); //clear the expanding animation
  activeGameData.mainGame.getBonusSymbolPickedOverlay().setVisible(false); //clear the bonus symbol overlay ingame
  activeGameData.mainGame.getBonusSymbolPickerBookAnimation().close(); //clear book selection screen

  //-reset the gamebar
  activeGameData.gameBar.setGambleButtonActive(false);
}

export function replayFn(activeGameData: GameData) {
  // activeGameData.mainGame.setWinlineHidden();
  let usedInput = activeGameData.GameContext().usedInputAction;

  if (activeGameData.bonusGameInfos.getMessageBox().getAlpha() == 1) {
    closeBonusWinMessageBox(activeGameData);
    activeGameData.replay.setClickable(true);

    if (activeGameData.replay.getIsNewRound()) {
      //if the previoys round or next round is clicked , it will close the message box but also spin new round
      startPlaying(activeGameData);
    }
  } else if (
    usedInput == activeGameData.API_handler.getServerActionBet() ||
    usedInput == activeGameData.API_handler.getServerActionBonusSpin()
    // || usedInput == activeGameData.API_handler.getServerActionRespin()
  ) {
    activeGameData.replay.setClickable(false);
    startPlaying(activeGameData);
    // if(usedInput == activeGameData.API_handler.getServerActionBonusSpin() && activeGameData.GameContext().allowedInputActions.indexOf(activeGameData.API_handler.getServerActionExpandBookOfTime())>=0)
    // {

    // }
  } else if (usedInput == activeGameData.API_handler.getServerActionCollect()) {
    onPlayButtonDown(activeGameData);
    activeGameData.replay.setClickable(true);
    activeGameData.replay.incrementIndex();
  } else if (usedInput == activeGameData.API_handler.getServerActionGamble()) {
    if (activeGameData.gambleGame.getGambleVisibility() == false) {
      gambleClick(activeGameData); //open Gamble game

      setTimeout(function() {
        activeGameData.gambleGame.setReplayPick();
        activeGameData.replay.incrementIndex();
        activeGameData.replay.setClickable(true);
      }, 500);
      // activeGameData.gambleGame.setReplayPick();
    } else {
      activeGameData.gambleGame.setReplayPick();
      activeGameData.replay.incrementIndex();
      activeGameData.replay.setClickable(true);
    }
  }
  //  else if (  usedInput == activeGameData.API_handler.getServerActionExpandBookOfTime())
  // {
  //   // console.log("set to", usedInput);
  //   activeGameData.replay.getNewStepData();
  //   activeGameData.mainGame.getExpandAnimation().reloadSkip();
  // }
  else {
    // console.log("Collect Game");
    activeGameData.replay.setClickable(true);
    activeGameData.gambleGame.startGamble(false);
    // activeGameData.replay.setClickable(true);
  }
}

export function betFailCallBack(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // gameBaseSetup.setErrorMessage(2);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}

export function recoverFail(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // console.log('recoverFail')
  // gameBaseSetup.setErrorMessage(0);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}

export function collectFailCallBack(
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  // gameBaseSetup.setErrorMessage(3);
  gameBaseSetup.setErrorMessage(6);
  disableAllBtns(activeGameData);
}
export function threeSecondCheckBetSuccess(
  data: any,
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  activeGameData;
  data;
  gameBaseSetup;
  let defaultSpinTime = 1700; //just an average  time of default game;
  let timeToWaitFromConfig =
    activeGameData.commonConfigData.minSpinDurationRequired - defaultSpinTime;
  let timeItTookAlready = Date.now() - activeGameData.spinTimeCounter;
  let timeToWait =
    timeItTookAlready >= timeToWaitFromConfig
      ? 0
      : timeToWaitFromConfig - timeItTookAlready;
  setTimeout(function() {
    betSuccessCallBack(data, activeGameData, gameBaseSetup);
  }, timeToWait);
}
export function betSuccessCallBack(
  data: any,
  activeGameData: GameData,
  gameBaseSetup?: GameBaseSetup<GameData>
) {
  // let test= new BonusSymbolPickerBookAnimation(activeGameData.coinsContainer,activeGameData);
  // test.startBonusAnimation();
  //-fakse
  // data={"gameContext":{"contextData":{"contextType":"DEFAULT","baseGameResult":{"reels":[[1,6,8],[9,9,9],[9,9,9],[1,9,6],[4,4,9]],"expandedReels":[false,true,true,false,false],"winCombinations":[]},"stake":{"amount":75,"currency":"EUR"},"win":{"credits":{"amount":0,"currency":"EUR"},"bonusSpins":0},"gameRoundBalance":{"credits":{"amount":52320,"currency":"EUR"},"bonusSpins":0},"gambleHistory":[],"bonus":false,"finished":false,"usedInputAction":"RESPIN","allowedInputActions":["EXPAND_WILDS"]}},"playerBalance":{"creditsBalance":{"amount":99925,"currency":"EUR"}}}

  activeGameData.betResponse = data;
  // translateCopyGameDataToLocalTaleOfTime(activeGameData,data);
  activeGameData.expandRequested = false;
  //--check santa to move
  // if (
  //   activeGameData.serverAction ==
  //   activeGameData.API_handler.getServerActionRespin()
  // ) {
  //   activeGameData.WildGame.moveToNewReel();
  //   // activeGameData.WildGame.
  // } else {
  //   activeGameData.WildGame.clearAll();
  // }

  //-add a flag to signal that there is expand animation active
  if (
    activeGameData
      .GameContext()
      .allowedInputActions.indexOf(
        activeGameData.API_handler.getServerActionExpandBookOfTime()
      ) >= 0
  ) {
    activeGameData.mainGame.setIsExpandBonusActive(true);
  } else {
    activeGameData.mainGame.setIsExpandBonusActive(false);
  }
  // console.log( activeGameData.mainGame.setExpandedWinlinesActive(true))

  //---

  enablePlay(false, activeGameData);

  if (activeGameData.freeSpinsCountReceived != activeGameData.freeSpinsCount) {
    //add the winnings for each spin of bonusgame on play button press because its autocollected by server and wont call otherwise
    activeGameData.freeSpinsWinning += activeGameData.winValue.getValue();

    activeGameData.gameBar.setFreeSpinWinValue(
      activeGameData.freeSpinsWinning.toFixed(2)
    );
  }

  activeGameData.mainGame.setGameStop(data.gameContext.contextData);

  activeGameData.infiniteSpin = false;
  // console.log(activeGameData.GameContext().winCombinations)
  let winComb = GetWinlineCombo(activeGameData);
  if (winComb != undefined) {
    activeGameData.winLength = winComb.length;
  } else {
    activeGameData.winLength = 0;
  }

  // if (activeGameData.GameContext().bonusGameResult!=undefined) {
  //   let bonusCountVisible = parseInt(
  //     activeGameData.bonusGameInfos.getSpinLeftText()
  //   );

  //   activeGameData.bonusGameInfos.setSpinLeftText(
  //     (bonusCountVisible - 1).toString()
  //   );
  //   console.log("SUBSTRACT",bonusCountVisible)
  // }
  activeGameData.mainGame.useBonus();
  // if (activeGameData.WildGame.isWildGameActive() == false) {
  //   activeGameData.mainGame.useBonus();
  // }

  activeGameData.gameSkippable = true;

  if (
    activeGameData.gameMode === "normalGame" &&
    activeGameData.replayMode == false
  ) {
    activeGameData.msgtotalBET += activeGameData.betSelected.value; //keep adding up each BET

    ///-reset bet
    if (
      activeGameData.GameContext().finished &&
      activeGameData.serverAction ==
        activeGameData.API_handler.getServerActionBet()
    ) {
      updateBalance(activeGameData);
    }

    updateBalanceOnly(activeGameData);
  }

  activeGameData.freeSpinMode.useSpins(activeGameData);

  // if (activeGameData.betResponse.hasOwnProperty("jackpotContext")) {

  //     stopAutoPlay(activeGameData);

  //     startJackpot(activeGameData);

  //     activeGameData.gameBar.setPlayButtonIndex(0)//change icon once collected
  //     // activeGameData.gameBar.playBtnMode = 0;
  // }
  // else {

  // }

  if (activeGameData.betResponse === null) {
    gameBaseSetup.setErrorMessage(5);
  }

  let bool = activeGameData.betResponse.hasOwnProperty("jackpotContext");
  if (bool == false) {
    enablePlay(true, activeGameData);
  } else {
    //jackpotWinCheck(activeGameData);

    //--handle the jackpot win at the end of bonus game
    let condition1BonusSpin =
      activeGameData.GameContext().usedInputAction ==
        activeGameData.API_handler.getServerActionBonusSpin() &&
      activeGameData.GameContext().gameRoundBalance.bonusSpins == 0; //if its bonus  game last spin without expand
    let condition2Expand =
      activeGameData.GameContext().usedInputAction ==
        activeGameData.API_handler.getServerActionExpandBookOfTime() &&
      activeGameData.GameContext().gameRoundBalance.bonusSpins == 0; //if its bonus  game last spin  with expand

    if (condition1BonusSpin || condition2Expand) {
      //--if the bonus is won at the end do not do anything
      //the jackpot will be triggered after closing the bonus game message
    } else {
      //  jackpotWinCheck(activeGameData);
      jackpotWinOnNonWinningGameSpin(activeGameData);
    }
  }

  //check if skip was clicked
  if (activeGameData.preSkip) {
    activeGameData.preSkip = false;
    activeGameData.skipGame(activeGameData);
  } else {
    activeGameData.gameBar.setPlayButtonIndex(1); //skippable
  }

  //-----------Replay mode fix the stake use
  activeGameData.replay.replayStakeUseCheck(); //use stake
  // activeGameData.stakeChangeSuccess

  // if(Math.random()>.7)
  //   activeGameData.newWinAnimation.displayWin(11111,1);
  //--update gameround id display
  activeGameData.gameRoundDisplayOverlay.updateGameRound(
    data.gameRoundId,
    activeGameData
  );

  //-on emulation substract the player stake
  updateEmulationStakeUse(activeGameData);
}

export function updateBalanceOnly(activeGameData: GameData) {
  if (activeGameData.freeSpinsActive == false) {
    if (activeGameData.updateBalanceOnRecovery) {
      activeGameData.balance.updateValue(
        activeGameData.betResponse.playerBalance.creditsBalance.amount
      );
      activeGameData.gameBar.setBalValue(
        activeGameData.balance.getDisplayValue()
      );
    }
  }
}

export function collectSuccessCallBack(
  data: any,
  activeGameData: GameData,
  gameBaseSetup: GameBaseSetup<GameData>
) {
  enablePlay(false, activeGameData);

  if (activeGameData.freeSpinsCountReceived != activeGameData.freeSpinsCount) {
    activeGameData.freeSpinsWinning += activeGameData.winValue.getValue();
    activeGameData.gameBar.setFreeSpinWinValue(
      activeGameData.freeSpinsWinning.toFixed(2)
    );
  }
  activeGameData.betResponse = data;
  // translateCopyGameDataToLocalTaleOfTime(activeGameData,data);
  setAllowedInputs(activeGameData);
  updateBalance(activeGameData);
  activeGameData.gameBar.setPlayButtonIndex(0); //change icon once collected
  // activeGameData.gameBar.playBtnMode = 0;
  // activeGameData.mainGame.winlines.hide();
  activeGameData.mainGame.setWinlineHidden(); //winlines.hide();

  activeGameData.winValue.updateValue(0); //reset win bar collect
  displayGambleBtn(false, activeGameData);
  // checkUserBalToBet(activeGameData);
  checkUserBalToBet(activeGameData);

  if (activeGameData.betResponse === null) {
    gameBaseSetup.setErrorMessage(5);
  }
  activeGameData.freeSpinMode.setMessageDisplay();

  let bool = activeGameData.betResponse.hasOwnProperty("jackpotContext");
  if (bool == false) {
    enablePlay(true, activeGameData);
  } else {
    // jackpotWinCheck(activeGameData);
    // jackpotWinCheck(activeGameData);
    jackpotWinOnNonWinningGameSpin(activeGameData);
  }

  if (activeGameData.replayMode) {
    activeGameData.replay.setClickable(true);
  }

  ///----------tournament points update-------
  activeGameData.tournamentUpdateScore();

  //--
  activeGameData.replay.replayCollectWinCheck();

  //update emulation balance if game round is ended
  updateEmulationWinBalance(activeGameData);
}

export function recoverSuccessCallBack(data: any, activeGameData: GameData) {
  if (activeGameData.bonusGameInfos.getIsVisibile()) {
    displayBonusGameInfosWindow(false, activeGameData);
  }

  activeGameData.betResponse = data; //overwrite the  data
  // translateCopyGameDataToLocalTaleOfTime(activeGameData,data);
  if (activeGameData.GameContext().finished) {
    //clear the winlines and winning if game is finished on recovering
    activeGameData.GameContext().win.credits.amount = 0;
    activeGameData.GameContext().baseGameResult.winCombinations = [];

    if (
      activeGameData.GameContext().bonusGameResult != undefined &&
      activeGameData.GameContext().bonusGameResult.winCombinations != undefined
    ) {
      activeGameData.GameContext().bonusGameResult.winCombinations = [];
    }
  }
  activeGameData.playable = true;
  if (
    !isNullOrUndefined(activeGameData.GameContext().bonusGameResult) &&
    activeGameData.GameContext().bonus
  ) {
    activeGameData.bonusGameModeStarted = true;
    activeGameData.bonusGameMode = true;
  } else {
    activeGameData.bonusGameModeStarted = false;
  }
  // console.log("recoverGameBarCall",activeGameData)
  recoverGameBar(activeGameData);
  activeGameData.mainGame.setGameStop(
    activeGameData.betResponse.gameContext.contextData
  );
  // console.log(data.gameContext.contextData )
  activeGameData.infiniteSpin = false;
  let winComb = GetWinlineCombo(activeGameData);
  if (winComb != undefined) {
    activeGameData.winLength = winComb.length;
  } else {
    activeGameData.winLength = 0;
  }

  activeGameData.mainGame.setMainGameContainerAlpha(1); //parentContainer.alpha = 1;
  setAllowedInputs(activeGameData);

  //-reload the background and music
  activeGameData.environment.checkBonusGameMusic();
  if (
    activeGameData.GameContext().usedInputAction ==
      activeGameData.API_handler.getServerActionBet() &&
    activeGameData.GameContext().bonus
  ) {
    // console.log('BONUS HAS YET TO START')
    activeGameData.environment.isBonusGame(false); //bonus game hasnt yet started
  }

  // reloadPillars
  if (
    activeGameData.GameContext().usedInputAction ==
    activeGameData.API_handler.getServerActionExpandBookOfTime()
  ) {
    activeGameData.mainGame.expandSuccess();
    activeGameData.mainGame.getExpandAnimation().reloadSkip();
  }
  //--update gameround id display
  activeGameData.gameRoundDisplayOverlay.updateGameRound(
    data.gameRoundId,
    activeGameData
  );
}
export function onKeyRelease(keyEvt: KeyboardEvent, activeGameData: GameData) {
  if (keyEvt.key === " ") {
    activeGameData.canSkipExpand = true;
    if (
      activeGameData.mainGame
        .getBonusSymbolPickerBookAnimation()
        .getIsEnded() &&
      activeGameData.mainGame.getBonusSymbolPickerBookAnimation().isVisible() &&
      activeGameData.replayMode == false
    ) {
      activeGameData.canSkipBonusSelectSymbol = true;
    } else {
      activeGameData.canSkipBonusSelectSymbol = false;
    }

    if (activeGameData.mainGame.getExpandAnimation().getSkippable()) {
      activeGameData.mainGame.getholdToSkipExpandBtn().onHoldStopped();
    }
  }
}
export function onKeyDown(keyEvt: KeyboardEvent, activeGameData: GameData) {
  // console.log(key.keyCode)
  if (keyEvt.key === " " && activeGameData.gameBar.getPlayButtonMode()) {
    if (activeGameData.mainGame.getIsGameStarted() === false) {
      activeGameData.playFunction();
      activeGameData.gameSkipped = false; //enable skip
      activeGameData.canSkipExpand = false;

      if (activeGameData.replayMode == false) {
        if (
          activeGameData.canSkipBonusSelectSymbol &&
          activeGameData.mainGame
            .getBonusSymbolPickerBookAnimation()
            .isVisible() &&
          activeGameData.mainGame
            .getBonusSymbolPickerBookAnimation()
            .getIsEnded()
        ) {
          activeGameData.canSkipBonusSelectSymbol = false;
          activeGameData.mainGame.getBonusSymbolPickerBookAnimation().close();
        }
        activeGameData.canSkipBonusSelectSymbol = false;
      }
    } else if (
      activeGameData.skipAnimation === false &&
      activeGameData.gameSkipped === false &&
      activeGameData.gameSkippable
    ) {
      activeGameData.playFunction();
      activeGameData.gameSkipped = true; //disable skip
      activeGameData.gameSkippable = false;
    }
  } else if (
    keyEvt.key === " " &&
    activeGameData.mainGame.getExpandAnimation().getSkippable() &&
    activeGameData.canSkipExpand
  ) {
    // activeGameData.mainGame.getExpandAnimation().onSkipClick()
    activeGameData.canSkipExpand = false;

    activeGameData.mainGame.getholdToSkipExpandBtn().onHoldStart();
  }
}

export function GetWinlineCombo(activeGameData: GameData) {
  let winlineComb;
  if (
    activeGameData.bonusGameMode &&
    activeGameData.bonusGameModeStarted &&
    activeGameData.GameContext().bonusGameResult != undefined
  ) {
    if (
      activeGameData.GameContext().bonusGameResult.winCombinations != undefined
    ) {
      winlineComb = activeGameData.GameContext().bonusGameResult
        .winCombinations;
    }
  } else {
    if (
      activeGameData.GameContext().baseGameResult.winCombinations != undefined
    ) {
      winlineComb = activeGameData.GameContext().baseGameResult.winCombinations;
    }
  }
  return winlineComb;
}

export function getWinContext(activeGameData: GameData) {
  let winlineComb;

  if (
    activeGameData.GameContext().bonusGameResult != undefined &&
    activeGameData.bonusGameModeStarted
  ) {
    winlineComb = activeGameData.GameContext().bonusGameResult;
  } else {
    if (activeGameData.GameContext().baseGameResult != undefined) {
      winlineComb = activeGameData.GameContext().baseGameResult;
    }
  }
  // console.log(winlineComb.expandedReels, "----");
  return winlineComb;
}
